import flatten from "lodash/flatten";
import isArray from "lodash/isArray";
import isNull from "lodash/isNull";
import isObject from "lodash/isObject";
import isUndefined from "lodash/isUndefined";

import { convertToSnakeCase } from "utils/jsonFetch";

export const convertToFormKeys = (object, prefix, inArray) =>
  flatten(
    Object.keys(object).map((key) => {
      const newKey = inArray ? "[]" : `[${key}]`;
      const val = isUndefined(object[key]) || isNull(object[key]) ? "" : object[key];

      if (isObject(val) && !(val instanceof File || val instanceof Blob)) {
        if (prefix && !isArray(val)) return convertToFormKeys(val, `${prefix}${newKey}`);
        if (prefix) return convertToFormKeys(val, `${prefix}${newKey}`, true);

        return convertToFormKeys(val, key);
      }

      if (prefix && !inArray) return [{ key: `${prefix}${newKey}`, val }];
      if (prefix) return [{ key: `${prefix}${newKey}`, val }];

      return [{ key, val }];
    })
  );

const createForm = (obj) => {
  const snakeObj = convertToSnakeCase(obj);
  const formData = new FormData();

  return convertToFormKeys(snakeObj).reduce((acc, val) => {
    acc.append(val.key, val.val);

    return formData;
  }, formData);
};

export default createForm;
